import { LocalizeRouterService } from 'localize-router';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { ApiService } from './api.service';
import { CarrelloService } from './carrello.service';
import { PreferitiService } from './preferiti.service';
import { StorageService } from './storage.service';
import { getOrigin } from '../util';
import * as i0 from "@angular/core";
import * as i1 from "./storage.service";
import * as i2 from "./api.service";
import * as i3 from "localize-router/src/localize-router.service";
import * as i4 from "./carrello.service";
import * as i5 from "./preferiti.service";
var AuthService = /** @class */ (function () {
    function AuthService(storage, api, localize, carrelloService, preferiti) {
        this.storage = storage;
        this.api = api;
        this.localize = localize;
        this.carrelloService = carrelloService;
        this.preferiti = preferiti;
    }
    Object.defineProperty(AuthService.prototype, "isLogged", {
        get: function () {
            return this.storage.getLocal('token-stem') && this.storage.getLocal('user-stem');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthService.prototype, "user", {
        get: function () {
            return this.storage.getLocal('user-stem');
        },
        set: function (user) {
            this.storage.setLocal('user-stem', user);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthService.prototype, "userId", {
        get: function () {
            return this.user ? this.user.idUtente : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthService.prototype, "token", {
        get: function () {
            return this.storage.getLocal('token-stem');
        },
        enumerable: true,
        configurable: true
    });
    AuthService.prototype.login = function (jsonIn) {
        var _this = this;
        jsonIn.idCarrello = this.storage.getLocal('carrello-stem') ? this.storage.getLocal('carrello-stem').idCarrello : null;
        jsonIn.language = this.localize.parser.currentLang.toUpperCase();
        return this.api.login(jsonIn).pipe(
        // Salvo in storage user e token
        switchMap((function (res) {
            if (res.esito === 'OK') {
                _this.storage.setLocal('token-stem', res.result.token);
                _this.storage.setLocal('user-stem', res.result);
            }
            return _this.carrelloService.aggiornaCarrello().pipe(map(function () { return res; }));
        })), switchMap((function (res) { return _this.preferiti.aggiornaPreferiti().pipe(map(function () { return res; })); })));
    };
    AuthService.prototype.logout = function () {
        var _this = this;
        var jsonIn = { token: this.token };
        return this.api.logout(jsonIn).pipe(map((function (res) {
            _this.svuotaStorage();
            return res;
        })));
    };
    AuthService.prototype.svuotaStorage = function () {
        this.storage.setLocal('token-stem', null);
        this.storage.setLocal('user-stem', null);
        this.storage.setLocal('preferiti-stem', null);
        this.storage.setLocal('carrello-stem', null);
        this.carrelloService.aggiornaCarrello().subscribe();
    };
    AuthService.prototype.registrazione = function (jsonIn) {
        jsonIn.language = this.localize.parser.currentLang.toUpperCase();
        jsonIn.idCarrello = this.storage.getLocal('idCarrello');
        jsonIn.urlPaginaAttivazioneCliente = getOrigin() + this.localize.translateRoute('/area-riservata').toString() + '/confirm-registration';
        console.log(jsonIn.urlPaginaAttivazioneCliente);
        return this.api.registrazione(jsonIn);
    };
    /** @nocollapse */ AuthService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AuthService_Factory() { return new AuthService(i0.ɵɵinject(i1.StorageService), i0.ɵɵinject(i2.ApiService), i0.ɵɵinject(i3.LocalizeRouterService), i0.ɵɵinject(i4.CarrelloService), i0.ɵɵinject(i5.PreferitiService)); }, token: AuthService, providedIn: "root" });
    return AuthService;
}());
export { AuthService };
